export default (axios) => ({
  statistic(params) {
    return axios.get("/admin/dashboard/users/statistic", { params: params });
  },
});
